/*=========================================================================================
  File Name: mutations.js
  Namespace: passes
  Description: Vuex Store - Pass mutations
==========================================================================================*/
import {
  buildPassState
} from './state'

const mutations = {
  STORE_CURRENT_PASS(state, pass) {
    state.currentPass = { ...state.currentPass, ...pass }
  },
  RESET_CURRENT_PASS(state) {
    state.currentPass = buildPassState()
  },
  STORE_LIST_PASSES(state, passes) {
    state.passList = {
      ...state.passList,
      ...passes.entries
    }
    state.count = passes.count
    state.next = passes.next
    state.previous = passes.previous
    state.results = [...passes.results]
  }
}

export default mutations

